import { render } from "./open-booking-form.template.html?vue&type=template&id=fea2b504&scoped=true"
import script from "./OpenBookingForm.vue?vue&type=script&lang=ts"
export * from "./OpenBookingForm.vue?vue&type=script&lang=ts"

import "./OpenBookingForm.vue?vue&type=style&index=0&id=fea2b504&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-fea2b504"

export default script